import { setHtml } from './css.js';
import { mountPopup } from './grid-util.js';
const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
const COLUMN_FIELDS = [
    { key: 'header', label: '머리글', kind: 'text', width: 110 },
    { key: 'width', label: '너비', kind: 'num', width: 56 },
    { key: 'pinned', label: '고정', kind: 'select', options: [['', '-'], ['left', '왼쪽'], ['right', '오른쪽']] },
    { key: 'align', label: '정렬', kind: 'select', options: [['', '자동'], ['left', '왼쪽'], ['center', '가운데'], ['right', '오른쪽']], dev: true },
    { key: 'format', label: '형식', kind: 'select', options: [['', '자동'], ['text', '문자'], ['number', '숫자'], ['money', '금액'], ['percent', '%'], ['date', '날짜'], ['datetime', '일시']], dev: true },
    { key: 'decimals', label: '소수', kind: 'num', dev: true, width: 40 },
    { key: 'editor', label: '편집기', kind: 'select', options: [['', '자동'], ['false', '읽기전용'], ['text', '문자'], ['number', '숫자'], ['date', '날짜'], ['combo', '콤보'], ['check', '체크']], dev: true },
    { key: 'required', label: '필수', kind: 'bool', dev: true },
    { key: 'summary', label: '합계', kind: 'select', options: [['', '-'], ['sum', '합계'], ['avg', '평균'], ['count', '건수'], ['min', '최소'], ['max', '최대']], dev: true },
    { key: 'merge', label: '병합', kind: 'select', options: [['', '-'], ['true', '항상'], ['sorted', '정렬 시']], dev: true },
    { key: 'suppress', label: '반복숨김', kind: 'bool', dev: true },
    { key: 'groupInterval', label: '그룹단위', kind: 'select', options: [['', '값'], ['date', '일'], ['month', '월'], ['year', '년'], ['firstChar', '첫글자']], dev: true },
    { key: 'sortable', label: '정렬가능', kind: 'bool', dev: true },
    { key: 'filterable', label: '필터가능', kind: 'bool', dev: true },
    { key: 'expr', label: '수식', kind: 'text', dev: true, width: 140 },
];
const OPTION_FIELDS = [
    { key: 'showRowNumber', label: '행 번호', kind: 'bool' },
    { key: 'showFilterRow', label: '필터 행', kind: 'bool' },
    { key: 'showFooter', label: '합계 행', kind: 'bool' },
    { key: 'showGroupPanel', label: '그룹 패널', kind: 'bool' },
    { key: 'hideGroupedColumns', label: '그룹 컬럼 숨김', kind: 'bool' },
    { key: 'showFilterPanel', label: '필터 패널', kind: 'select', options: [['auto', '필터 있을 때'], ['true', '항상'], ['false', '숨김']] },
    { key: 'columnFilterMenu', label: '헤더 필터 메뉴', kind: 'bool' },
    { key: 'findPanel', label: '찾기(Ctrl+F)', kind: 'bool' },
    { key: 'rowHeight', label: '행 높이', kind: 'num' },
    { key: 'footerLabel', label: '합계 이름', kind: 'text' },
    { key: 'editable', label: '편집 가능', kind: 'bool', dev: true },
    { key: 'showRowState', label: '행 상태 표시', kind: 'bool', dev: true },
    { key: 'showCheckbox', label: '체크 컬럼', kind: 'bool', dev: true },
    { key: 'enterKey', label: 'Enter 이동', kind: 'select', options: [['next', '다음 입력칸'], ['down', '아래 행']], dev: true },
    { key: 'appendRowOnTab', label: '마지막 칸에서 새 행', kind: 'bool', dev: true },
    { key: 'incrementalSearch', label: '증분 검색', kind: 'bool', dev: true },
    { key: 'rowDrag', label: '행 드래그', kind: 'bool', dev: true },
    { key: 'emptyText', label: '자료 없음 문구', kind: 'text', dev: true },
];
export function openGridDesigner(grid) {
    document.querySelector('.og-designer')?.remove();
    const dev = grid.opts.customize === 'developer';
    const t = grid.t;
    // 설정 창 낱말은 'designer|' 문맥 키 (같은 한국어가 다른 뜻인 '일'·'월' 등과 겹치지 않게)
    const L = (k) => t('designer|' + k);
    const d = document.createElement('div');
    d.className = 'og-builder og-designer';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-label', L('그리드 설정'));
    mountPopup(grid, d);
    let tab = 'cols';
    const notify = () => grid.notifyLayout?.();
    const colVal = (c, f) => { const v = c[f.key]; return v === undefined || v === null ? '' : typeof v === 'function' ? '(함수)' : String(v); };
    const draw = () => {
        const cols = grid.opts.columns;
        let body = '';
        if (tab === 'cols') {
            const fields = COLUMN_FIELDS.filter(f => dev || !f.dev);
            body = `<div class="og-dtable"><table><thead><tr><th>${L('표시')}</th><th>${L('순서')}</th><th>ID</th>${fields.map(f => `<th>${esc(L(f.label))}</th>`).join('')}</tr></thead><tbody>${cols.map((c, i) => grid.columnAccess(c) === 'hidden' ? '' : `<tr data-i="${i}">
<td><input type="checkbox" data-k="hidden"${c.hidden ? '' : ' checked'} aria-label="${esc(t('designer|{col} 표시', { col: c.id }))}"></td>
<td class="og-dord"><button type="button" data-up${i ? '' : ' disabled'}>↑</button><button type="button" data-down${i < cols.length - 1 ? '' : ' disabled'}>↓</button></td>
<td class="og-did">${esc(c.id)}</td>
${fields.map(f => {
                const v = colVal(c, f), fn = v === '(함수)';
                if (f.kind === 'bool')
                    return `<td><input type="checkbox" data-k="${f.key}"${c[f.key] ? ' checked' : ''}${fn ? ' disabled' : ''}></td>`;
                if (f.kind === 'select')
                    return `<td><select data-k="${f.key}"${fn ? ' disabled' : ''}>${fn ? `<option>${esc(L('(함수)'))}</option>` : ''}${f.options.map(([k, l]) => `<option value="${k}"${v === k ? ' selected' : ''}>${esc(L(l))}</option>`).join('')}</select></td>`;
                return `<td><input data-k="${f.key}" ${f.kind === 'num' ? 'type="number"' : ''} value="${esc(fn ? L('(함수)') : v)}" style="width:${f.width ?? 80}px"${fn ? ' disabled' : ''}></td>`;
            }).join('')}</tr>`).join('')}</tbody></table></div>`;
        }
        else if (tab === 'grid') {
            const o = grid.opts;
            body = `<div class="og-dopts">${OPTION_FIELDS.filter(f => dev || !f.dev).map(f => {
                const v = o[f.key];
                if (f.kind === 'bool')
                    return `<label><input type="checkbox" data-o="${f.key}"${v ? ' checked' : ''}> ${esc(L(f.label))}</label>`;
                if (f.kind === 'select')
                    return `<label>${esc(L(f.label))} <select data-o="${f.key}">${f.options.map(([k, l]) => `<option value="${k}"${String(v ?? f.options[0][0]) === k ? ' selected' : ''}>${esc(L(l))}</option>`).join('')}</select></label>`;
                return `<label>${esc(L(f.label))} <input data-o="${f.key}" ${f.kind === 'num' ? 'type="number"' : ''} value="${esc(v ?? '')}"></label>`;
            }).join('')}
<label>${L('그룹 컬럼')} <input data-o="groupBy" value="${esc(grid.getGroupBy().join(','))}" placeholder="dept,labNm"></label></div>`;
        }
        else {
            body = `<textarea data-k="json" rows="16" aria-label="${L('레이아웃 JSON')}">${esc(JSON.stringify(grid.getLayout(), null, 2))}</textarea>
<div class="og-mrow"><button type="button" data-a="applyjson">${L('JSON 적용')}</button><button type="button" data-a="copy">${L('복사')}</button><button type="button" data-a="code">${L('컬럼 코드 복사 (개발자)')}</button><button type="button" data-a="reset">${L('처음 설정으로')}</button></div>`;
        }
        setHtml(d, `<div class="og-bhead"><b>${L('그리드 설정')}${dev ? ' ' + L('(개발자)') : ''}</b><div class="og-btabs"><button type="button" data-t="cols" aria-pressed="${tab === 'cols'}">${L('컬럼')}</button><button type="button" data-t="grid" aria-pressed="${tab === 'grid'}">${L('그리드')}</button>${dev ? `<button type="button" data-t="layout" aria-pressed="${tab === 'layout'}">${L('레이아웃(JSON)')}</button>` : ''}</div></div>
<div class="og-bbody">${body}</div><div class="og-bprev" aria-live="polite">${L('바꾸면 바로 적용됩니다.')}${grid.opts.layoutKey ? ' ' + L('화면 설정은 이 브라우저에 저장됩니다.') : ''}</div>
<div class="og-mrow og-mbtns"><button type="button" class="og-mok" data-a="close">${L('닫기')}</button></div>`);
    };
    draw();
    const msg = (t) => { const p = d.querySelector('.og-bprev'); if (p)
        p.textContent = t; };
    d.addEventListener('click', async (e) => {
        const b = e.target.closest('button');
        if (!b)
            return;
        if (b.dataset.t) {
            tab = b.dataset.t;
            draw();
            return;
        }
        const tr = b.closest('tr[data-i]');
        if (tr && (b.hasAttribute('data-up') || b.hasAttribute('data-down'))) {
            const i = +tr.dataset.i, j = b.hasAttribute('data-up') ? i - 1 : i + 1;
            const cols = [...grid.opts.columns];
            [cols[i], cols[j]] = [cols[j], cols[i]];
            grid.setColumns(cols, grid.opts.headerGroups);
            notify();
            draw();
            return;
        }
        const a = b.dataset.a;
        if (a === 'close') {
            d.remove();
            grid.focusGrid();
        }
        else if (a === 'applyjson') {
            try {
                grid.applyLayout(JSON.parse(d.querySelector('[data-k=json]').value));
                msg(L('레이아웃을 적용했습니다'));
            }
            catch (err) {
                msg(L('JSON 오류') + ': ' + err.message);
            }
        }
        else if (a === 'copy') {
            await navigator.clipboard?.writeText(JSON.stringify(grid.getLayout(), null, 2)).catch(() => { });
            msg(L('레이아웃 JSON 을 복사했습니다'));
        }
        else if (a === 'code') {
            const code = 'const columns: GridColumn[] = ' + JSON.stringify(grid.getLayout().columns, null, 2).replace(/"(\w+)":/g, '$1:');
            await navigator.clipboard?.writeText(code).catch(() => { });
            msg(L('컬럼 정의 코드를 복사했습니다 (함수 속성은 원래 코드에서 유지)'));
        }
        else if (a === 'reset') {
            grid.resetLayout();
            draw();
            msg(L('처음 설정으로 되돌렸습니다'));
        }
    });
    const onChange = (e) => {
        const t = e.target;
        if (t.dataset.k && t.dataset.k !== 'json') {
            const tr = t.closest('tr[data-i]');
            const c = grid.opts.columns[+tr.dataset.i];
            const k = t.dataset.k;
            let v;
            if (k === 'hidden')
                v = !t.checked;
            else if (t.type === 'checkbox')
                v = t.checked;
            else if (t.type === 'number')
                v = t.value === '' ? undefined : Number(t.value);
            else
                v = t.value === '' ? undefined : t.value === 'true' ? true : t.value === 'false' ? false : t.value;
            if (k === 'expr' && v) {
                try {
                    grid.setColumnProperty(c.id, k, v);
                    msg(`${c.id}: ${L('수식 적용')}`);
                }
                catch (err) {
                    msg(L('수식 오류') + ': ' + err.message);
                }
                return;
            }
            grid.setColumnProperty(c.id, k, v);
            msg(`${c.header ?? c.id}: ${String(k)} ${L('변경')}`);
        }
        else if (t.dataset.o) {
            const k = t.dataset.o;
            if (k === 'groupBy') {
                const g = t.value.split(',').map(x => x.trim()).filter(Boolean);
                grid.setGroupBy(g.length ? g : null);
                return;
            }
            let v = t.type === 'checkbox' ? t.checked : t.type === 'number' ? Number(t.value) : t.value;
            if (k === 'showFilterPanel')
                v = v === 'auto' ? 'auto' : v === 'true';
            grid.setOptions({ [k]: v });
            notify();
            msg(`${k} ${L('변경')}`);
        }
    };
    d.addEventListener('change', onChange);
    d.addEventListener('keydown', e => { if (e.key === 'Escape') {
        d.remove();
        grid.focusGrid();
    } });
}
